import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Box, Tabs, Tab, Tooltip } from '@mui/material';

import * as settings from "../../settings"

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SettingsIcon from '@mui/icons-material/Settings';

import KeyStats from './KeyStats';
import LevelSelect from './LevelPicker';
import SchoolsListGrid from './SchoolsList';
import MapHeader from './MapHeader';
import SidebarDrawer from './SidebarDrawer';
import { SchoolIcon } from '../Icons/SchoolIcon';
import { Level, Plan } from '../../atom/atom'
import { useRecoilValue, useRecoilState } from 'recoil';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    const headerHeight = "48px"
    const tabsHeight = "49px"

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{
                    height: `calc(100vh - ${headerHeight} - ${tabsHeight})`, // TODO:
                    textAlign: "left",
                    display: "flex",
                    flexDirection: "column"
                }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function MapSidebar(props) {
    const mapSettings = props.mapSettings
    const [drawerOpen, setDrawerOpen] = React.useState(false);
    const [school, setSchool] = React.useState({});
    const [schools, setSchools] = useState()
    const [planData, setPlanData] = useState({})
    const level = useRecoilValue(Level)
    const plan = useRecoilValue(Plan)
    useEffect(() => {
        axios.get(`${settings.API_SERVER}/api/plan_detail/${plan}/`)
            .then((res) => {
                setPlanData(res.data)
            })
            .catch((e) => {
                console.log('error getting plan data', e)
            })
    }, [])

    useEffect(() => {
        axios.get(`${settings.API_SERVER}/api/school_data/${plan}/${level}/`).then((res) => {
            setSchools(res.data.schools)
        })
    }, [level])

    const sidebarSettings = {
        drawerOpen: drawerOpen,
        school: school,
        schools: schools,
        setDrawerOpen,
        setSchool,
        setSchools,
    }

    const handleChange = (event, newValue) => {
        mapSettings.setTab(newValue);
    };

    return (
        <React.Fragment>
            <Box sx={{ zIndex: (theme) => theme.zIndex.drawer + 100 }}>
                {planData ? <MapHeader name={planData.name} /> : null}
                <Tabs
                    variant="fullWidth"
                    value={mapSettings.tab}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tooltip title="Schools">
                        <Tab icon={<SchoolIcon sx={{ "&:hover": { color: "grey.main" } }} />} {...a11yProps(0)} />
                    </Tooltip>
                    <Tooltip title="Key stats">
                        <Tab icon={<InfoOutlinedIcon sx={{ "&:hover": { color: "grey.main" } }} />} {...a11yProps(1)} />
                    </Tooltip>
                    <Tooltip title="Settings">
                        <Tab icon={<SettingsIcon sx={{ "&:hover": { color: "grey.main" } }} />} {...a11yProps(3)} />
                    </Tooltip>
                </Tabs>
                <TabPanel value={mapSettings.tab} index={0}>
                    <LevelSelect settings={props.mySettings} />
                    <SchoolsListGrid settings={props.mySettings} sidebarSettings={sidebarSettings} map={props.map} />
                </TabPanel>
                <TabPanel value={mapSettings.tab} index={1}>
                    <KeyStats settings={props.mySettings} map={props.map} sidebarSettings={sidebarSettings} />
                </TabPanel>
                <TabPanel value={mapSettings.tab} index={3}>
                    Item Three
                </TabPanel>
            </Box>
            <SidebarDrawer sidebarSettings={sidebarSettings} />
        </React.Fragment>
    )
};